/// <amd-module name="Test/Analytics/TestResultsGrid/Actions/TestResultsGridActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class TestResultsGridActions {
    public readonly updateReportsWithConfigurationAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public readonly updateTestOutcomeMetricsAction: Action<CommonTypes.ICardMetricsData> = new Action<CommonTypes.ICardMetricsData>();
    public readonly updateDetailedTestListAction: Action<CommonTypes.IDetailedListData> = new Action<CommonTypes.IDetailedListData>();
    public readonly detailedTestListColumnOrderChangedAction: Action<CommonTypes.IDetailedListColumn> = new Action<CommonTypes.IDetailedListColumn>();
    public readonly detailedTestListSortByColumnAction: Action<null> = new Action<null>();
    public readonly detailedListShowMoreAction: Action<CommonTypes.IDetailedListData> = new Action<CommonTypes.IDetailedListData>();
    public readonly detailedListShowMoreInsideGroupAction: Action<CommonTypes.IDetailedListGroupData> = new Action<
        CommonTypes.IDetailedListGroupData
    >();
    public readonly initializingTestResultsAction: Action<null> = new Action<null>();
    public readonly onError: Action<Error> = new Action<Error>();
}
